import { ProjectsContainer } from "../../ProjectPage/ProjectsContainer/ProjectsContainer";
import { useGetProjectsByFolderId } from "../../../services/projectService";
import { useGetFolderById } from "../../../services/folderService";

type Props = {
  folderId?: string;
};

export const FolderDetailContainer = ({ folderId }: Props) => {
  const { data: projects } = useGetProjectsByFolderId(folderId);
  const { data: folder } = useGetFolderById(folderId);

  return (
    <div className="mt-3">
      <h4 className="mb-5">{folder ? folder.name : ""}</h4>
      <ProjectsContainer projects={projects || []} folderId={folderId} />
    </div>
  );
};
